import { Outlet, Link } from "react-router-dom";

import styles from "./Layout.module.css";

const Layout = () => {
    return (
        <div className={styles.layout}>
            {/* <header className={styles.header} role={"banner"}>
                <div className={styles.headerContainer}>
                    <Link to="/" className={styles.headerTitleContainer}>
                        <img 
                            src="https://upload.wikimedia.org/wikipedia/commons/0/0c/Logo_del_DNP_%282022-2026%29.png" 
                            alt="DNP Logo"
                            className={styles.dnpLogo}
                        />
                        <h3 className={styles.headerTitle}>Librería inteligente</h3>
                    </Link>
                    <div className={styles.headerRightSection}>
                        <span className={styles.headerSubtitle}>Explorador de documentos</span>
                    </div>
                </div>
            </header> */}

            <Outlet />
        </div>
    );
};

export default Layout;
